export function getSeasonBoundaryDate(
  timestamp?: number,
  boundary: "start" | "end" = "start"
): Date | undefined {
  if (timestamp === undefined) {
    return undefined;
  }

  const date = new Date(timestamp);

  return boundary === "start"
    ? new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    : new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
        999
      );
}
